module.exports = __webpack_public_path__ + "static/img/11.1323517.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/11.png
// module id = V08Z
// module chunks = 0